import {VariableAlarmSettings} from '../variable-alarm-type-eligibility.model';
export const templates: Map<string, VariableAlarmSettings> = new Map<string, VariableAlarmSettings>(
    [
        [
            'runningToilet',
            {
                allocationUnit: 'RT',
                unit: 86,
                deviationType: 'I',
                deviationValue: 1,
                minimumDeviationPeriod: 120,
            },
        ],
        [
            'indoorClimateHumidityHigh',
            {
                allocationUnit: 'R',
                unit: 14,
                deviationType: 'I',
                deviationValue: 75,
                minimumDeviationPeriod: 300,
            },
        ],
        [
            'indoorClimateHumidityLow',
            {
                allocationUnit: 'R',
                unit: 14,
                deviationType: 'D',
                deviationValue: 30,
                minimumDeviationPeriod: 1440,
            },
        ],
        [
            'indoorClimateHumidityLeakage',
            {
                allocationUnit: 'R',
                unit: 14,
                deviationType: 'I',
                deviationValue: 75,
                minimumDeviationPeriod: 300,
            },
        ],
        [
            'indoorClimateTemperatureHigh',
            {
                allocationUnit: 'C',
                unit: 10,
                deviationType: 'I',
                deviationValue: 24,
                minimumDeviationPeriod: 720,
            },
        ],
        [
            'indoorClimateTemperatureLow',
            {
                allocationUnit: 'C',
                unit: 10,
                deviationType: 'D',
                deviationValue: 16,
                minimumDeviationPeriod: 720,
            },
        ],
        [
            'indoorClimateCo2High',
            {
                allocationUnit: 'AD',
                unit: 79,
                deviationType: 'I',
                deviationValue: 1000,
                minimumDeviationPeriod: 60,
            },
        ],
        [
            'customizedAlarm',
            {
                allocationUnit: 'customAlarm',
                unit: null,
                deviationType: null,
                deviationValue: null,
                minimumDeviationPeriod: null,
            },
        ],
    ],
);
